import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M12 3C8.68286 3 6 5.817 6 9.3C6 12.783 12 21 12 21C12 21 18 12.783 18 9.3C18 5.817 15.3171 3 12 3ZM12 18.3C12 18.3 7.71429 12 7.71429 9.3C7.71429 6.816 9.63429 4.8 12 4.8C14.3657 4.8 16.2857 6.816 16.2857 9.3C16.2857 12 12 18.3 12 18.3ZM13.7143 9.498C13.7143 10.488 12.9429 11.298 12 11.298C11.0571 11.298 10.2857 10.488 10.2857 9.498C10.2857 8.508 11.0571 7.698 12 7.698C12.9429 7.698 13.7143 8.499 13.7143 9.498Z' />
        </SvgIcon>
    );
});
